import { Route, Routes } from 'react-router-dom';
import NotFound from '../screens/Auth/NotFound';
import HelpCreateScreen from '../screens/CreateGame/HelpCreate';
import CreateMainScreen from '../screens/CreateGame/CreateMain';
import CreateMemoryGameContentEditScreen from '../screens/CreateGame/CreateMemoryGameContentEdit';
import CreateMemoryGameSelectTypeScreen from '../screens/CreateGame/CreateMemoryGameSelectType';
import CreateMemoryGameEnterContentScreen from '../screens/CreateGame/CreateMemoryGameEnterContent';
import CreateMemoryGameContentListScreen from '../screens/CreateGame/CreateMemoryGameContentList';
import CreateMemoryGameSelectWordsScreen from '../screens/CreateGame/CreateMemoryGameSelectWords';
import CreateMemoryGameSelectGamesScreen from '../screens/CreateGame/CreateMemoryGameSelectGames';
import CreateMemoryGameProcessedContentScreen from '../screens/CreateGame/CreateMemoryGameProcessedContent';
import CreateMemoryGameProcessedContentExampleScreen from '../screens/CreateGame/CreateMemoryGameProcessedContentExample';

const CreateMemoryGameRoute: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<CreateMainScreen />} />
      <Route path="/help" element={<HelpCreateScreen />} />
      <Route
        path="/select-type"
        element={<CreateMemoryGameSelectTypeScreen />}
      />
      <Route
        path="/input-content"
        element={<CreateMemoryGameEnterContentScreen />}
      />
      <Route
        path="/processed-content-example"
        element={<CreateMemoryGameProcessedContentExampleScreen />}
      />
      <Route
        path="/processed-content"
        element={<CreateMemoryGameProcessedContentScreen />}
      />
      <Route
        path="/generated-games"
        element={<CreateMemoryGameContentListScreen />}
      />
      <Route
        path="/edit-game"
        element={<CreateMemoryGameContentEditScreen />}
      />
      <Route
        path="/select-words"
        element={<CreateMemoryGameSelectWordsScreen />}
      />
      <Route
        path="/select-games"
        element={<CreateMemoryGameSelectGamesScreen />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default CreateMemoryGameRoute;
